var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 31,
    viewBox: "0 0 21 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.86561 25.8403C9.09922 26.1916 9.49154 26.4023 9.91239 26.4023C10.3332 26.4023 10.7256 26.1916 10.9592 25.8403C10.9592 25.8403 14.7361 20.1476 17.0026 15.0254C18.0405 12.6786 18.7467 10.433 18.7467 8.83665C18.7467 3.96041 14.7878 0.000406265 9.91239 0.000406265C5.03697 0.000406265 1.07812 3.96041 1.07812 8.83665C1.07812 10.433 1.78429 12.6786 2.82214 15.0254C5.08866 20.1476 8.86561 25.8403 8.86561 25.8403ZM9.91239 22.8133C8.6659 20.8136 6.57059 17.2907 5.11902 14.0094C4.24701 12.0406 3.58898 10.1759 3.58898 8.83665C3.58898 5.34599 6.42256 2.51299 9.91239 2.51299C13.4022 2.51299 16.2358 5.34599 16.2358 8.83665C16.2358 10.1759 15.5778 12.0406 14.7058 14.0094C13.2542 17.2907 11.1589 20.8136 9.91239 22.8133Z",
    fill: "#1B293E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.9949 22.1231C17.3629 22.628 17.5814 23.1855 17.5814 23.7795C17.5814 24.6825 17.0841 25.495 16.3118 26.1719C14.9015 27.4089 12.6134 28.1749 10.0465 28.1749C7.47963 28.1749 5.19152 27.4089 3.78124 26.1719C3.00891 25.495 2.51163 24.6825 2.51163 23.7795C2.51163 23.2722 2.6711 22.7912 2.94738 22.3467C3.31407 21.7589 3.13326 20.9841 2.54428 20.6174C1.95656 20.2507 1.1817 20.4315 0.815007 21.0205C0.283797 21.8732 0 22.805 0 23.7795C0 25.3719 0.763517 26.8663 2.12482 28.0606C3.91435 29.6291 6.79019 30.6865 10.0465 30.6865C13.3028 30.6865 16.1787 29.6291 17.9682 28.0606C19.3295 26.8663 20.093 25.3719 20.093 23.7795C20.093 22.6594 19.7175 21.5932 19.0231 20.6425C18.6137 20.0824 17.8275 19.9594 17.2674 20.3688C16.7086 20.7769 16.5855 21.5643 16.9949 22.1231Z",
    fill: "#1B293E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 11C11.1046 11 12 10.1046 12 9C12 7.89543 11.1046 7 10 7C8.89543 7 8 7.89543 8 9C8 10.1046 8.89543 11 10 11Z",
    fill: "#1B293E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIcon);
export default __webpack_public_path__ + "static/media/location-icon.cabfb4d41daa9e96234bcd2f80603cb3.svg";
export { ForwardRef as ReactComponent };